"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
// Expose EVA document signing services
//
var DocumentSigning;
(function (DocumentSigning) {
    // This service generates a QR code that can be scanned to provide
    // the possibility to sign an order with an digital autograph
    //
    function getSigningCodeForOrder(orderId) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetSigningCodeForOrder");
            // Construct the request object
            //
            var requestData = {
                OrderID: orderId,
            };
            // Perform the XHR call
            //
            service.call(requestData)
                .then(function (serviceResult) { resolve(serviceResult.response); })
                .catch(function (error) { reject(error); });
        });
    }
    DocumentSigning.getSigningCodeForOrder = getSigningCodeForOrder;
    // Retrieve the order data after you scanned the QR code
    //
    function getSigningDataForOrder(hashId) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetSigningDataForOrder");
            // Construct the request object
            //
            var requestData = {
                Hash: hashId,
            };
            // Perform the XHR call
            //
            service.call(requestData)
                .then(function (serviceResult) { resolve(serviceResult.response); })
                .catch(function (error) { reject(error); });
        });
    }
    DocumentSigning.getSigningDataForOrder = getSigningDataForOrder;
    // Sign the order with the autograph (blob)
    //
    function signOrder(signature, mimeType, hashId) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("SignOrder");
            // Construct the request object
            //
            var requestData = {
                Signature: signature,
                MimeType: mimeType,
                Hash: hashId,
            };
            // Perform the XHR call
            //
            service.call(requestData)
                .then(function (serviceResult) { resolve(serviceResult.response); })
                .catch(function (error) { reject(error); });
        });
    }
    DocumentSigning.signOrder = signOrder;
})(DocumentSigning = exports.DocumentSigning || (exports.DocumentSigning = {}));
